/* eslint-disable no-shadow */
// StatusBadge.jsx
import PropTypes from "prop-types";
import React from "react";

const StatusBadge = ({ status }) => {
  const getStatusColors = (status) => {
    switch (status?.toUpperCase()) {
      case "PENDING":
      case "RTA_RECTIFY":
        return {
          backgroundColor: "#E7A0071A",
          dotColor: "#E7A007",
          textColor: "#E7A007",
        };
      case "IN_PROGRESS":
        return {
          backgroundColor: "#2196F31A",
          dotColor: "#2196F3",
          textColor: "#2196F3",
        };
      case "ISSUED":
      case "APPROVED":
      case "COMPLETED":
      case "RTA_APPROVED":
        return {
          backgroundColor: "#1D6D001A",
          dotColor: "#1D6D00",
          textColor: "#1D6D00",
        };
      case "FAILED":
      case "RTA_REJECT":
        return {
          backgroundColor: "#F443361A",
          dotColor: "#F44336",
          textColor: "#F44336",
        };

      default:
        return {
          backgroundColor: "#9E9E9E1A",
          dotColor: "#9E9E9E",
          textColor: "#9E9E9E",
        };
    }
  };

  const { backgroundColor, dotColor, textColor } = getStatusColors(status);

  const formatStatus = (status) => {
    if (!status) return "N/A";
    return status
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div
      style={{
        borderRadius: "30px",
        backgroundColor,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "0.2rem 0.5rem",
        }}
      >
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: dotColor,
          }}
        />
        <span style={{ color: textColor }}>{formatStatus(status)}</span>
      </div>
    </div>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadge;